/** Байты → "200 КБ" / "1,5 МБ". */
export function formatFileSize(bytes: number): string {
  const b = Number.isFinite(bytes) ? bytes : 0;
  if (b >= 1_048_576) {
    return `${(b / 1_048_576).toLocaleString('ru-RU', {
      maximumFractionDigits: 1,
    })} МБ`;
  }
  if (b >= 1024) {
    return `${Math.round(b / 1024)} КБ`;
  }
  return `${b} Б`;
}

/** "2026-06-28T10:00:00Z" → "28.06.2026". Пустая строка, если не распознали. */
export function formatDocDate(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso ?? '');
  return m ? `${m[3]}.${m[2]}.${m[1]}` : '';
}

export type RenderKind = 'image' | 'pdf' | 'video';
export type PreviewKind = RenderKind | 'office' | 'other';

const IMAGE_EXT = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'avif'];
const VIDEO_EXT = ['mp4', 'webm', 'ogg', 'ogv', 'mov', 'm4v', 'avi', 'mkv'];
const OFFICE_EXT = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];

/** Расширение файла из имени в нижнем регистре ("Отчёт.PDF" → "pdf"). */
export function getExtension(name: string): string {
  const match = /\.([a-z0-9]+)\s*$/i.exec((name ?? '').trim());
  return match ? match[1].toLowerCase() : '';
}

/** Тип предпросмотра по расширению имени файла. */
export function getKindFromExt(ext: string): PreviewKind {
  if (IMAGE_EXT.includes(ext)) {
    return 'image';
  }
  if (ext === 'pdf') {
    return 'pdf';
  }
  if (VIDEO_EXT.includes(ext)) {
    return 'video';
  }
  if (OFFICE_EXT.includes(ext)) {
    return 'office';
  }
  return 'other';
}

/** Тип рендера по MIME (приоритетнее расширения — ловит подменённые расширения). */
export function getRenderKindFromMime(mime: string): RenderKind | null {
  const t = (mime ?? '').toLowerCase();
  if (t.startsWith('image/')) {
    return 'image';
  }
  if (t.includes('pdf')) {
    return 'pdf';
  }
  if (t.startsWith('video/')) {
    return 'video';
  }
  return null;
}

export function isAbsoluteHttpUrl(url: string): boolean {
  return /^https?:\/\//i.test(url ?? '');
}
